'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');
var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);
var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  width: ', 'px;\n  height: ', 'px;\n  position: relative;\n  display: flex;\n'], ['\n  width: ', 'px;\n  height: ', 'px;\n  position: relative;\n  display: flex;\n']);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _Svg = require('../Svg');
var _Svg2 = _interopRequireDefault(_Svg);
var _View = require('../View');
var _View2 = _interopRequireDefault(_View);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var IconWrapper = (0, _styledComponents2.default)(_View2.default)(_templateObject, function (props) {
  return props.width;
}, function (props) {
  return props.height;
});
var Icon = function Icon(_ref) {
  var color = _ref.color,
    width = _ref.width,
    height = _ref.height,
    viewBox = _ref.viewBox,
    svgPath = _ref.svgPath,
    className = _ref.className;
  return _react2.default.createElement(IconWrapper, {
    width: width,
    height: height,
    className: className
  }, _react2.default.createElement(_Svg2.default, {
    viewBox: viewBox,
    svgPath: svgPath,
    color: color,
    width: width,
    height: height
  }));
};
Icon.propTypes = {
  svgPath: _propTypes2.default.string.isRequired,
  color: _propTypes2.default.string,
  width: _propTypes2.default.number,
  height: _propTypes2.default.number,
  viewBox: _propTypes2.default.string,
  className: _propTypes2.default.string
};
Icon.defaultProps = {
  color: '#4a4a4a',
  viewBox: '0 0 24 24',
  width: 48,
  height: 48
};
exports.default = Icon;